import clsx from 'clsx'
import { forwardRef } from 'react'
import { TextInput, type TextInputProps } from '../text-input'

export interface CurrencyInputProps extends Omit<TextInputProps, 'value' | 'onChange' | 'type'> {
  value: string | null
  onChange: (value: string | null) => void
}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ value, onChange, className, ...props }, ref) => {
    return (
      <div className="flex items-center">
        <span className="mr-1">$</span>
        <span className="w-[125px] block">
          <TextInput
            ref={ref}
            type="number"
            inputMode="decimal"
            min={0}
            step="0.01"
            value={value ?? ''}
            onChange={(event) => {
              const next = event.target.value
              onChange(next === '' ? null : next)
            }}
            className={clsx('text-right h-8', className)}
            {...props}
          />
        </span>
      </div>
    )
  }
)

CurrencyInput.displayName = 'CurrencyInput'
